import { useId } from 'react';
import { cx } from './cx.js';

/**
 * Interrupteur pour un réglage qui s'applique tout de suite.
 * Avec `label` : ligne complète (libellé à gauche, 44 px min.). Sans : l'interrupteur
 * seul, `aria-label` obligatoire. Libellé formulé sur l'état activé (« Sons »).
 */
export function Switch({ checked, onChange, label, hint, disabled, className, 'aria-label': ariaLabel }: {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}) {
  const labelId = useId();
  const button = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label ? undefined : ariaLabel}
      aria-labelledby={label ? labelId : undefined}
      disabled={disabled}
      className="pl-switch"
      onClick={() => onChange?.(!checked)}
    >
      <span className="pl-switch-knob" />
    </button>
  );
  if (!label) return button;
  return (
    <div className={cx('pl-switch-row', className)}>
      <span className="pl-switch-text">
        <span id={labelId}>{label}</span>
        {hint && <span className="pl-switch-hint">{hint}</span>}
      </span>
      {button}
    </div>
  );
}
